import React, { ReactNode } from "react";
import { HardHat, Hammer, Ruler, Zap } from "lucide-react";
import styles from "./PeopleSearchHero.module.scss";

type QuickSkill = {
  id: number;
  name: string;
};

type PeopleSearchHeroProps = {
  quickSkills: QuickSkill[];
  onSelectSkill: (skillId: number) => void;
  searchBar?: ReactNode;
  isCompact?: boolean;
};

const PeopleSearchHero = ({
  quickSkills,
  onSelectSkill,
  searchBar,
  isCompact = false,
}: PeopleSearchHeroProps) => {
  return (
    <section className={`${styles.hero} ${isCompact ? styles.hero_compact : ""}`.trim()}>
      <div
        className={`${styles.collapsible} ${isCompact ? styles.collapsible_hidden : ""}`.trim()}
        aria-hidden={isCompact}
      >
        <div className={styles.intro}>
          <h1 className={styles.title}>Buscá perfiles para tu obra</h1>
          <p className={styles.subtitle}>
            Profesionales, empresas y trabajadores. Buscá por nombre, filtrá por especialidad y ubicación, o describí lo que necesitás con IA.
          </p>
        </div>
      </div>
      {searchBar && <div className={styles.searchBarWrapper}>{searchBar}</div>}
      <div
        className={`${styles.collapsible} ${isCompact ? styles.collapsible_hidden : ""}`.trim()}
        aria-hidden={isCompact}
      >
        {quickSkills.length > 0 && (
          <div className={styles.tilesSection}>
            <span className={styles.tilesLabel}>Atajos por especialidad</span>
            <div className={styles.tiles}>
              {quickSkills.slice(0, 4).map((skill, index) => (
                <button
                  key={skill.id}
                  type="button"
                  className={styles.tile}
                  onClick={() => onSelectSkill(skill.id)}
                >
                  <span className={styles.tileIcon}>
                    {index === 0 && <HardHat size={14} />}
                    {index === 1 && <Hammer size={14} />}
                    {index === 2 && <Zap size={14} />}
                    {index === 3 && <Ruler size={14} />}
                  </span>
                  <span className={styles.tileLabel}>{skill.name}</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default PeopleSearchHero;

